module.exports = __webpack_public_path__ + "img/fav.7741d475.webp";